import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTierPricePoint.ChangedPricesFromExcel.IRequest;
type Headers = Api.Core.ProductTierPricePoint.ChangedPricesFromExcel.IHeaders;
type Response = Api.Core.ProductTierPricePoint.ChangedPricesFromExcel.IResponse;
const url = '/api/ProductManagement/ProductTierPricePoint/ChangedPricesFromExcel/:productId';
export async function productTierPricePointChangedPricesFromExcelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    body,
    url: createPathFromRoute(url, { productId: body.productId }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
